export default "__VITE_ASSET__LN_wtOuH__"